<template>
  <v-navigation-drawer v-if="!isMobile && !isNative" width="auto" v-model="show_drawer" :mini-variant.sync="mini"
      :expand-on-hover="!isMobile" app v-resize="checkMobile">
      <v-list-item class="pr-1 pl-3">
        <v-list-item-content class="">
          <v-toolbar-title v-if="mini">
            <router-link to="/dashboard" class="mx-0 d-flex align-middle">
              <v-avatar size="30" class="mt-1">
                <img src="/img/logo-100x100.png" alt="RentProg">
              </v-avatar>
            </router-link>
          </v-toolbar-title>
          <v-toolbar-title v-if="!mini">
            <router-link to="/dashboard"
              :class="$vuetify.theme.dark ? 'white--text text-decoration-none d-flex align-middle' : 'black--text text-decoration-none d-flex align-middle'">
              <v-avatar size="30" class="mr-2 mt-1">
                <img src="/img/logo-100x100.png" alt="RentProg">
              </v-avatar>
              <span class="pt-1 font-weight-light text-decoration-none">RentProg</span>
            </router-link>
          </v-toolbar-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-1"></v-divider>
      <v-list v-if="isAdminPlus ||
      user_role == 'guest'
      " dense>
        <v-list-item to="/dashboard" @click="closeOnContentClick = true">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.main") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
          <v-list-item-action>
            <v-icon>mdi-book-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
          <v-list-item-action>
            <v-icon>mdi-view-column</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/calendars/timeline" @click="closeOnContentClick = true">
          <v-list-item-action>
            <v-icon>mdi-calendar-cursor</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.day_plan") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/calendars/gantt" @click="closeOnContentClick = true">
          <v-list-item-action>
            <v-icon>mdi-chart-gantt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.calendar") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/booking/new" @click="closeOnContentClick = true">
          <v-list-item-action>
            <v-icon>mdi-plus-box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{
      $t("custom.add_booking")
    }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/search_free" @click="closeOnContentClick = true">
          <v-list-item-action>
            <v-icon>mdi-car-search-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{
      $t("custom.search_free")
    }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group v-for="item in items" :key="item.title" v-model="item.active" :prepend-icon="item.icon" no-action>
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
            style="padding-left: 25px !important" :to="subItem.to">
            <v-list-item-action>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ subItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item to="/tasks" @click="closeOnContentClick = true" v-if="isStaff">
          <v-list-item-action>
            <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("tasks.menu") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/store" @click="closeOnContentClick = true">
          <v-list-item-action>
            <v-icon>mdi-store-cog</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("store.store") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/ai-assistant" @click="closeOnContentClick = true" v-if="includedInPlan('ai_assistant')">
          <v-list-item-action>
            <v-icon color="info">mdi-robot-excited</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("ai_assistant.title") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="company && company.whatsapp && isStaff"
          to="/whatsapp_chat">
          <v-list-item-action>
            <v-icon>mdi-whatsapp</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>WhatsApp</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      <v-list-item to="/transactions" @click="closeOnContentClick = true" v-if="isInternal && !isInvoiceClient">
        <v-list-item-action>
          <v-icon color="success">mdi-currency-usd</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            <span :class="$store.getters.getMainCompany &&
        $store.getters.getMainCompany.balance < 0
        ? 'red--text'
        : ''
      ">
              {{ $t("header.balance") }}:
              {{
        $store.getters.getMainCompany
          ? Math.round($store.getters.getMainCompany.balance)
          : 0
      }}
              <span>{{
        $store.getters.getMainCompany &&
          $store.getters.getMainCompany.currency == "RUB"
          ? "₽"
          : "€"
      }}</span>
          </span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item to="/transactions" @click="closeOnContentClick = true" v-else-if="isInternal && isInvoiceClient">
        <v-list-item-action>
          <v-icon color="primary">mdi-file-document-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("tariffs.billing") }}</v-list-item-title>
        </v-list-item-content>
    </v-list-item>
    <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
      }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else-if="user_role == 'manager'" dense>
      <v-list-item to="/dashboard" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.main") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-book-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-view-column</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/timeline" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-cursor</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.day_plan") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/gantt" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-chart-gantt</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.calendar") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/booking/new" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-plus-box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
      $t("custom.add_booking")
    }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/search_free" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-car-search-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
      $t("custom.search_free")
    }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-for="item in manager_items" :key="item.title" v-model="item.active" :prepend-icon="item.icon"
        no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
          style="padding-left: 25px !important" :to="subItem.to">
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item to="/store" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-store-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("store.store") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/tasks" @click="closeOnContentClick = true" v-if="isStaff">
        <v-list-item-action>
          <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("tasks.menu") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/schedule_calendar" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-multiselect</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.schedule") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/salary" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-account-cash-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.salary") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/admin/users" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-account-hard-hat</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.employers") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="company && company.whatsapp && isStaff"
        to="/whatsapp_chat">
        <v-list-item-action>
          <v-icon>mdi-whatsapp</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>WhatsApp</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
      }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else-if="user_role == 'partner'" dense>
      <v-list-item to="/dashboard" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.main") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-book-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-view-column</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/investor_analytics" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-poll</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.analitics") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/timeline" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-cursor</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.day_plan") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/gantt" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-chart-gantt</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.calendar") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-for="item in partners_items" :key="item.title" v-model="item.active" :prepend-icon="item.icon"
        no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
          style="padding-left: 25px !important" :to="subItem.to">
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
      }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else-if="user_role == 'agent'" dense>
      <v-list-item to="/booking/new" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-plus-box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
      $t("custom.add_booking")
    }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/search_free" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-car-search-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
      $t("custom.search_free")
    }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-book-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-view-column</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-for="item in agents_items" :key="item.title" v-model="item.active" :prepend-icon="item.icon"
        no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
          style="padding-left: 25px !important" :to="subItem.to">
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
      }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else dense>
      <v-list-item to="/dashboard" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.main") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-book-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-view-column</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/timeline" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-cursor</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.day_plan") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/gantt" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-chart-gantt</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.calendar") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/booking/new" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-plus-box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
      $t("custom.add_booking")
    }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/search_free" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-car-search-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
      $t("custom.search_free")
    }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-for="item in worker_items" :key="item.title" v-model="item.active" :prepend-icon="item.icon"
        no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
          style="padding-left: 25px !important" :to="subItem.to">
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item to="/store" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-store-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("store.store") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/tasks" @click="closeOnContentClick = true" v-if="isStaff">
        <v-list-item-action>
          <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("tasks.menu") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="company && company.whatsapp && isStaff"
        to="/whatsapp_chat">
        <v-list-item-action>
          <v-icon>mdi-whatsapp</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>WhatsApp</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/schedule_calendar" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-multiselect</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.schedule") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/salary" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-account-cash-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.salary") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
  <v-navigation-drawer v-else v-model="show_drawer" width="auto" app v-resize="checkMobile"
    :class="isIos ? 'ios-drawer' : ''">
    <v-list-item :class="isIos ? 'pr-1 pl-3 pt-10' : 'pr-1 pl-3'">
      <v-list-item-content class="">
        <v-toolbar-title>
          <router-link to="/dashboard"
            :class="$vuetify.theme.dark ? 'white--text text-decoration-none d-flex align-middle' : 'black--text text-decoration-none d-flex align-middle'">
            <v-avatar size="30" class="mr-2 mt-1">
              <img src="/img/logo-100x100.png" alt="RentProg">
            </v-avatar>
            <span class="pt-2 font-weight-light text-decoration-none">RentProg</span>
          </router-link>
        </v-toolbar-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>
    <v-list v-if="isAdminPlus ||
    user_role == 'guest'
    " dense class="pt-0 overflow-y-auto">
      <v-list-item to="/dashboard" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.main") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-book-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-view-column</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/timeline" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-cursor</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.day_plan") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/gantt" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-chart-gantt</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.calendar") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/booking/new" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-plus-box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
    $t("custom.add_booking")
  }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/search_free" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-car-search-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
    $t("custom.search_free")
  }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-for="item in items" :key="item.title" v-model="item.active" :prepend-icon="item.icon" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
          style="padding-left: 25px !important" :to="subItem.to">
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <!-- FT-081 rework: обычная ссылка — клик = навигация, триал НЕ стартует отсюда.
           Триал-доступный админ попадает на страницу CRM с intro и явной кнопкой «Подключить». -->
      <v-list-item to="/crm/leads" @click="closeOnContentClick = true"
        v-if="(isCrmEnabled && hasCrmAccess) || (crmTrialAvailable && isCrmAdmin)">
        <v-list-item-action>
          <v-icon>mdi-account-multiple-plus</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("crm.menu.leads") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/tasks" @click="closeOnContentClick = true" v-if="isStaff">
        <v-list-item-action>
          <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("tasks.menu") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/store" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-store-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("store.store") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="company && company.whatsapp && isStaff"
        to="/whatsapp_chat">
        <v-list-item-action>
          <v-icon>mdi-whatsapp</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>WhatsApp</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    <v-list-item to="/transactions" @click="closeOnContentClick = true" v-if="isInternal && !isInvoiceClient">
      <v-list-item-action>
        <v-icon color="success">mdi-currency-usd</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          <span :class="$store.getters.getMainCompany &&
      $store.getters.getMainCompany.balance < 0
      ? 'red--text'
      : ''
    ">
            {{ $t("header.balance") }}:
            {{
    $store.getters.getMainCompany
      ? Math.round($store.getters.getMainCompany.balance)
      : 0
  }}
            <span>{{
      $store.getters.getMainCompany &&
        $store.getters.getMainCompany.currency == "RUB"
        ? "₽"
        : "€"
    }}</span>
          </span>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item to="/transactions" @click="closeOnContentClick = true" v-else-if="isInternal && isInvoiceClient">
      <v-list-item-action>
        <v-icon color="primary">mdi-file-document-outline</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>{{ $t("tariffs.billing") }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else-if="user_role == 'manager'" dense class="pt-0 overflow-y-auto"
      :style="isMobile ? 'max-height: 500px' : 'max-height: 1000px'">
      <v-list-item to="/dashboard" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.main") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-book-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-view-column</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/timeline" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-cursor</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.day_plan") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/gantt" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-chart-gantt</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.calendar") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/booking/new" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-plus-box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
    $t("custom.add_booking")
  }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/search_free" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-car-search-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
    $t("custom.search_free")
  }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-for="item in manager_items" :key="item.title" v-model="item.active" :prepend-icon="item.icon"
        no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
          style="padding-left: 25px !important" :to="subItem.to">
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item to="/store" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-store-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("store.store") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/tasks" @click="closeOnContentClick = true" v-if="isStaff">
        <v-list-item-action>
          <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("tasks.menu") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/schedule_calendar" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-multiselect</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.schedule") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/salary" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-account-cash-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.salary") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/admin/users" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-account-hard-hat</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.employers") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="company && company.whatsapp && isStaff"
        to="/whatsapp_chat">
        <v-list-item-action>
          <v-icon>mdi-whatsapp</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>WhatsApp</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- FT-081 rework: обычная ссылка — клик = навигация, триал НЕ стартует отсюда.
           Триал-доступный админ попадает на страницу CRM с intro и явной кнопкой «Подключить». -->
      <v-list-item to="/crm/leads" @click="closeOnContentClick = true"
        v-if="(isCrmEnabled && hasCrmAccess) || (crmTrialAvailable && isCrmAdmin)">
        <v-list-item-action>
          <v-icon>mdi-account-multiple-plus</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("crm.menu.leads") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else-if="user_role == 'partner'" dense class="pt-0 overflow-y-auto"
      :style="isMobile ? 'max-height: 500px' : 'max-height: 1000px'">
      <v-list-item to="/dashboard" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.main") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-book-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-view-column</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/timeline" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-cursor</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.day_plan") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/gantt" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-chart-gantt</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.calendar") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-for="item in partners_items" :key="item.title" v-model="item.active" :prepend-icon="item.icon"
        no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
          style="padding-left: 25px !important" :to="subItem.to">
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else-if="user_role == 'agent'" dense class="pt-0 overflow-y-auto"
      :style="isMobile ? 'max-height: 500px' : 'max-height: 1000px'">
      <v-list-item to="/booking/new" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-plus-box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
    $t("custom.add_booking")
  }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/search_free" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-car-search-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
    $t("custom.search_free")
  }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-book-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-view-column</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-for="item in agents_items" :key="item.title" v-model="item.active" :prepend-icon="item.icon"
        no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
          style="padding-left: 25px !important" :to="subItem.to">
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list v-else dense class="pt-0 overflow-y-auto" :style="isMobile ? 'max-height: 500px' : 'max-height: 1000px'">
      <v-list-item to="/dashboard" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.main") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/list" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-book-multiple</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/bookings/board" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-view-column</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.bookings_board") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/timeline" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-cursor</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.day_plan") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/calendars/gantt" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-chart-gantt</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.calendar") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/booking/new" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-plus-box</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
    $t("custom.add_booking")
  }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/search_free" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-car-search-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{
    $t("custom.search_free")
  }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group v-for="item in worker_items" :key="item.title" v-model="item.active" :prepend-icon="item.icon"
        no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list-item v-for="subItem in item.items" :key="subItem.title" @click="closeOnContentClick = true"
          style="padding-left: 25px !important" :to="subItem.to">
          <v-list-item-action>
            <v-icon>{{ subItem.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ subItem.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item to="/store" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-store-cog</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("store.store") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/tasks" @click="closeOnContentClick = true" v-if="isStaff">
        <v-list-item-action>
          <v-icon>mdi-checkbox-marked-circle-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("tasks.menu") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-if="company && company.whatsapp && isStaff"
        to="/whatsapp_chat">
        <v-list-item-action>
          <v-icon>mdi-whatsapp</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>WhatsApp</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/schedule_calendar" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-calendar-multiselect</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.schedule") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item to="/salary" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-account-cash-outline</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.salary") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true">
        <v-list-item-action>
          <v-icon>mdi-help-circle</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-group prepend-icon="mdi-lifebuoy" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t("support.support") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item :href="`https://rentprog.${$root.$i18n.locale == 'ru' ? 'ru' : 'com'
    }/${$root.$i18n.locale}/helpcenter`" target="_blank" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-help-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("custom.help") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/support/tickets" @click="closeOnContentClick = true"
          style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-ticket-account</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.tickets") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Живой чат: на мобильных Crisp-пузырь скрыт (перекрывал контент),
             чат открывается отсюда. Роли без чата — как в AppHeader. -->
        <v-list-item v-if="isStaff"
          @click="openSupportChat" style="padding-left: 25px !important">
          <v-list-item-action>
            <v-icon>mdi-chat-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ $t("support.chat") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="signOut()">
        <v-list-item-action>
          <v-icon color="error">mdi-logout-variant</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("header.sign_out") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { Capacitor } from "@capacitor/core";
import moment from "moment";
import { markIntentionalLogout } from "@/utils/sessionExpiry";
export default {
  data() {
    return {
      mini: true,
      items: [
        {
          icon: "mdi-car-multiple",
          title: this.menu_object_name(),
          active: false,
          items: [
            {
              title: this.menu_object_name(),
              icon: "mdi-car-multiple",
              to: "/vehicles/list",
            },
            {
              title: this.$t("custom.add_car"),
              icon: "mdi-plus-box",
              to: "/cars/new",
            },
          ],
        },
        {
          icon: "mdi-calendar-account-outline",
          title: this.$t("custom.clients"),
          active: false,
          items: [
            {
              title: this.$t("custom.clients"),
              icon: "mdi-calendar-account-outline",
              to: "/clients",
            },
            {
              title: this.$t("custom.fines"),
              icon: "mdi-car-emergency",
              to: "/fines",
            },
            {
              title: this.$t("custom.debts"),
              icon: "mdi-credit-card-remove-outline",
              to: "/debts",
            },
            {
              title: this.$t("custom.invoices"),
              icon: "mdi-receipt",
              to: "/invoices",
            },
            {
              title: this.$t("custom.add_client"),
              icon: "mdi-plus-box",
              to: "/client/new",
            },
          ],
        },
        {
          icon: "mdi-cash-register",
          title: this.$t("custom.counts"),
          active: false,
          items: [
            {
              title: this.$t("custom.counts"),
              icon: "mdi-cash-register",
              to: "/counts",
            },
            {
              title: this.$t("header.company_counts"),
              icon: "mdi-cash-lock",
              to: "/company_counts",
            },
            {
              title: this.$t("header.add_payment"),
              icon: "mdi-book-plus-multiple",
              to: "/counts/new",
            },
          ],
        },
        {
          icon: "mdi-book-plus-multiple",
          title: this.$t("custom.service"),
          active: false,
          items: [
            {
              title: this.$t("custom.tech_service"),
              icon: "mdi-car-cog",
              to: "/service_tech",
            },
            {
              title: this.$t("maintenance.insurances_and_taxes"),
              icon: "mdi-shield-car",
              to: "/service_insurance",
            },
            {
              title: this.$t("maintenance.payments"),
              icon: "mdi-cash-sync",
              to: "/service_payments",
            },
          ],
        },
        {
          icon: "mdi-domain",
          title: this.$t("header.company"),
          active: false,
          items: [
            {
              title: this.$t("custom.analitics"),
              icon: "mdi-chart-areaspline",
              to: "/analitics",
            },
            {
              title: this.$t("custom.employers"),
              icon: "mdi-account-hard-hat",
              to: "/admin/users",
            },
            {
              title: this.$t("custom.schedule"),
              icon: "mdi-calendar-multiselect",
              to: "/schedule_calendar",
            },
            {
              title: this.$t("custom.salary"),
              icon: "mdi-account-cash-outline",
              to: "/salary",
            },
            {
              title: this.$t("header.partners"),
              icon: "mdi-handshake-outline",
              to: "/investors",
            },
            {
              title: this.$t("header.branches"),
              icon: "mdi-source-branch",
              to: "/branches",
            },
            {
              title: this.$t("custom.contractors"),
              icon: "mdi-account-convert",
              to: "/contractors",
            },
            {
              title: this.$t("home.events"),
              icon: "mdi-history",
              to: "/history",
            },
            {
              title: this.$t("header.company_settings"),
              icon: "mdi-cog-box",
              to: "/company_profile",
            },
            {
              title: this.$t("agents.agents"),
              icon: "mdi-face-agent",
              to: "/agents",
            },
          ],
        },
      ],
      selected_items: [],
      worker_items: [
        {
          icon: "mdi-car-multiple",
          title: this.menu_object_name(),
          active: false,
          items: [
            {
              title: this.menu_object_name(),
              icon: "mdi-car-multiple",
              to: "/vehicles/list",
            },
            {
              title: this.$t("custom.add_car"),
              icon: "mdi-plus-box",
              to: "/cars/new",
            },
          ],
        },
        {
          icon: "mdi-calendar-account-outline",
          title: this.$t("custom.clients"),
          active: false,
          items: [
            {
              title: this.$t("custom.clients"),
              icon: "mdi-calendar-account-outline",
              to: "/clients",
            },
            {
              title: this.$t("custom.fines"),
              icon: "mdi-car-emergency",
              to: "/fines",
            },
            {
              title: this.$t("custom.debts"),
              icon: "mdi-credit-card-remove-outline",
              to: "/debts",
            },
            {
              title: this.$t("custom.invoices"),
              icon: "mdi-receipt",
              to: "/invoices",
            },
            {
              title: this.$t("custom.add_client"),
              icon: "mdi-plus-box",
              to: "/client/new",
            },
          ],
        },
        {
          icon: "mdi-cash-register",
          title: this.$t("custom.counts"),
          active: false,
          items: [
            {
              title: this.$t("custom.counts"),
              icon: "mdi-cash-register",
              to: "/counts",
            },
            {
              title: this.$t("header.add_payment"),
              icon: "mdi-book-plus-multiple",
              to: "/counts/new",
            },
            {
              title: this.$t("custom.contractors"),
              icon: "mdi-account-convert",
              to: "/contractors",
            },
          ],
        },
        {
          icon: "mdi-book-plus-multiple",
          title: this.$t("custom.service"),
          active: false,
          items: [
            {
              title: this.$t("custom.tech_service"),
              icon: "mdi-car-cog",
              to: "/service_tech",
            },
            {
              title: this.$t("maintenance.insurances_and_taxes"),
              icon: "mdi-shield-car",
              to: "/service_insurance",
            },
            {
              title: this.$t("maintenance.payments"),
              icon: "mdi-cash-sync",
              to: "/service_payments",
            },
          ],
        },
      ],
      manager_items: [
        {
          icon: "mdi-car-multiple",
          title: this.menu_object_name(),
          active: false,
          items: [
            {
              title: this.menu_object_name(),
              icon: "mdi-car-multiple",
              to: "/vehicles/list",
            },
            {
              title: this.$t("custom.add_car"),
              icon: "mdi-plus-box",
              to: "/cars/new",
            },
          ],
        },
        {
          icon: "mdi-calendar-account-outline",
          title: this.$t("custom.clients"),
          active: false,
          items: [
            {
              title: this.$t("custom.clients"),
              icon: "mdi-calendar-account-outline",
              to: "/clients",
            },
            {
              title: this.$t("custom.fines"),
              icon: "mdi-car-emergency",
              to: "/fines",
            },
            {
              title: this.$t("custom.debts"),
              icon: "mdi-credit-card-remove-outline",
              to: "/debts",
            },
            {
              title: this.$t("custom.invoices"),
              icon: "mdi-receipt",
              to: "/invoices",
            },
            {
              title: this.$t("custom.add_client"),
              icon: "mdi-plus-box",
              to: "/client/new",
            },
          ],
        },
        {
          icon: "mdi-cash-register",
          title: this.$t("custom.counts"),
          active: false,
          items: [
            {
              title: this.$t("custom.counts"),
              icon: "mdi-cash-register",
              to: "/counts",
            },
            {
              title: this.$t("header.add_payment"),
              icon: "mdi-book-plus-multiple",
              to: "/counts/new",
            },
            {
              title: this.$t("custom.contractors"),
              icon: "mdi-account-convert",
              to: "/contractors",
            },
          ],
        },
        {
          icon: "mdi-book-plus-multiple",
          title: this.$t("custom.service"),
          active: false,
          items: [
            {
              title: this.$t("custom.tech_service"),
              icon: "mdi-car-cog",
              to: "/service_tech",
            },
            {
              title: this.$t("maintenance.insurances_and_taxes"),
              icon: "mdi-shield-car",
              to: "/service_insurance",
            },
            {
              title: this.$t("maintenance.payments"),
              icon: "mdi-cash-sync",
              to: "/service_payments",
            },
          ],
        },
      ],
      partners_items: [
        {
          icon: "mdi-car-multiple",
          title: this.menu_object_name(),
          active: false,
          items: [
            {
              title: this.menu_object_name(),
              icon: "mdi-car-multiple",
              to: "/vehicles/list",
            },
          ],
        },
        {
          icon: "mdi-book-plus-multiple",
          title: this.$t("custom.service"),
          active: false,
          items: [
            {
              title: this.$t("custom.tech_service"),
              icon: "mdi-car-cog",
              to: "/service_tech",
            },
            {
              title: this.$t("maintenance.insurances_and_taxes"),
              icon: "mdi-shield-car",
              to: "/service_insurance",
            },
            {
              title: this.$t("maintenance.payments"),
              icon: "mdi-cash-sync",
              to: "/service_payments",
            },
          ],
        },
      ],
      agents_items: [
        {
          icon: "mdi-cash-register",
          title: this.$t("custom.counts"),
          active: false,
          items: [
            {
              title: this.$t("custom.counts"),
              icon: "mdi-cash-register",
              to: "/counts",
            },
            {
              title: this.$t("header.add_payment"),
              icon: "mdi-book-plus-multiple",
              to: "/counts/new",
            },
          ],
        },
      ],
      isMobile: false,
    };
  },
  created() {
    // if(this.isMobile) {
    //   this.$store.commit("setDrawer", false);
    // }
  },
  computed: {
    appVersion() {
      return this.$store.getters.appVersion;
    },
    isCrmEnabled() {
      return this.$store.getters["crm/isCrmEnabled"];
    },
    hasCrmAccess() {
      return this.$store.getters["crm/hasCrmAccess"];
    },
    // FT-081 follow-up: скоуп CTA «Попробовать CRM» — тариф предлагает crm_module,
    // триал ещё не брали и CRM не подключён (см. src/store/modules/crm/getters.js).
    crmTrialAvailable() {
      return this.$store.getters["crm/crmTrialAvailable"];
    },
    isCrmAdmin() {
      return this.$store.getters["crm/isCrmAdmin"];
    },
    isInvoiceClient() {
      return this.$store.getters.getMainCompany?.payment_provider_preference === 'paddle' &&
             this.$store.getters.getMainCompany?.plan?.billing_collection_method === 'invoice';
    },
    main_company() {
      return this.$store.getters.getMainCompany;
    },
    new_booking() {
      return this.$store.getters.getNewBookingState;
    },
    isNative() {
      return Capacitor.isNativePlatform();
    },
    isPushNotificationsAvailable() {
      return Capacitor.isPluginAvailable("PushNotifications");
    },
    isIos() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ? true : false;
    },
    isAndroid() {
      return Capacitor.getPlatform().toLowerCase() == "android" ? true : false;
    },
    company_id() {
      if (
        this.$store.getters.getCompany &&
        this.$store.getters.getCompany.company
      ) {
        return this.$store.getters.getCompany.company.id;
      } else {
        return null;
      }
    },
    company() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company) {
        return this.$store.getters.getCompany.company;
      } else {
        return null;
      }
    },
    show_drawer: {
      get: function () {
        return this.$store.getters.getDrawer
      },
      set: function (newValue) {
        this.$store.commit("setDrawer", newValue)
      }
    },
  },
  methods: {
    openSupportChat() {
      this.closeOnContentClick = true;
      if (typeof $crisp === "undefined" || !$crisp || !$crisp.push) return;
      $crisp.push(["do", "chat:show"]);
      $crisp.push(["do", "chat:open"]);
    },
    rental_object() {
      if (this.$store.getters.getCompany && this.$store.getters.getCompany.company && this.$store.getters.getCompany.company.rental_object) {
        return this.$store.getters.getCompany.company.rental_object;
      } else {
        return 'cars';
      }
    },
    menu_object_name() {
      let name = '';
      if (this.rental_object() === 'cars') {
        name = this.$t("rental_objects.cars_menu");
      } else if (this.rental_object() === 'bicycles') {
        name = this.$t("rental_objects.bicycles_menu");
      } else if (this.rental_object() === 'motorcycles') {
        name = this.$t("rental_objects.motorcycles_menu");
      } else if (this.rental_object() === 'boats') {
        name = this.$t("rental_objects.boats_menu");
      } else if (this.rental_object() === 'construction_machinery') {
        name = this.$t("rental_objects.construction_machinery_menu");
      } else if (this.rental_object() === 'equipment') {
        name = this.$t("rental_objects.equipment_menu");
      } else if (this.rental_object() === 'airplanes') {
        name = this.$t("rental_objects.airplanes_menu");
      } else if (this.rental_object() === 'trucks') {
        name = this.$t("rental_objects.trucks_menu");
      } else if (this.rental_object() === 'trailers') {
        name = this.$t("rental_objects.trailers_menu");
      } else if (this.rental_object() === 'caravans') {
        name = this.$t("rental_objects.caravans_menu");
      } else if (this.rental_object() === 'taxies') {
        name = this.$t("rental_objects.taxies_menu");
      } else if (this.rental_object() === 'other') {
        name = this.$t("rental_objects.other_menu");
      }
      return name;
    },
    includedInPlan(service) {
      if (this.$store.getters.getMainCompany) {
        if (this.$store.getters.getMainCompany.plan) {
          if (this.$store.getters.getMainCompany.plan.included_services) {
            // check trial period
            if (this.$store.getters.getMainCompany.plan.trial_end && moment(this.$store.getters.getMainCompany.plan.trial_end).isAfter(moment()) && service != 'multicashboxes' && service != 'multicurrency') {
              return true;
            }
            return this.$store.getters.getMainCompany.plan.included_services.includes(service);
          }
        }
      }
      return false;
    },
    replaceToProfile() {
      this.$router.push({ name: "Profile" }).catch(err => { });
    },
    replaceToSalary() {
      this.$router.push({ name: "Salary" }).catch(err => { });
    },
    replaceToCheckLists() {
      this.$router.push({ name: "CheckList" }).catch(err => { });
    },
    replaceToSchedule() {
      this.$router.push({ name: "ScheduleCalendar" }).catch(err => { });
    },
    replaceToCompanyProfile() {
      this.$router.push({ name: "CompanyProfile" }).catch(err => { });
    },
    replaceToCompanyCounts() {
      this.$router.push({ name: "CompanyCounts" }).catch(err => { });
    },
    reverseDrawer() {
      return this.$store.commit("setDrawer", !this.$store.getters.getDrawer);
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    currentUser() {
      return this.$store.getters.getCurrentUser;
    },
    checkAdmin() {
      return this.$store.getters.isAdmin;
    },
    checkManager() {
      return this.$store.getters.isManager;
    },
    signOut() {
      let self = this;
      // FT-136: выход завершается локально при любом исходе запроса (см. App.vue).
      this.axios(
        markIntentionalLogout({
          url: "users/sign_out",
          baseURL: this.$store.getters.getApiUrl, // FT-018
          method: "delete",
          headers: { Authorization: self.$store.getters.getAuthToken },
        })
      )
        .catch((error) => {
          if (!(error && error.response && error.response.status === 401)) {
            self.setError(error, self.$t("errors.sign_out_unconfirmed"));
            // setError молчит на транзиентных сетевых обрывах (их индицирует баннер) — а
            // здесь молчать нельзя: именно при обрыве отзыв токена точно не состоялся.
            // Прямой $notify гарантирует предупреждение при любом не-401 исходе; на 5xx
            // он перезаписывает общий тост setError — последний вызов в снекбаре побеждает.
            self.$notify(self.$t("errors.attention"), self.$t("errors.sign_out_unconfirmed"), "warning", 6000);
          }
          console.log(error);
        })
        .finally(() => {
          self.isLoading = false;
          self.$store.commit("unsetCurrentUser");
        });
    },
    closeDrawer: function () {
      return this.$store.commit("setDrawer", false);
    }
  },
  components: {}
};
</script>
<!-- <style>
.drawer-logo {
  padding: 0 !important;
}

.ios-drawer {
  padding-top: env(safe-area-inset-top);
}

.ios-drawer .v-list {
  padding-top: 0;
}

/* Убираем старый отступ */
.v-navigation-drawer {
  margin-top: 0 !important;
}

/* Добавляем стили для корректного отображения на iOS */
.v-navigation-drawer--is-mobile {
  padding-top: env(safe-area-inset-top);
}

/* Стили для контента внутри drawer */
.v-navigation-drawer .v-list {
  padding-top: 0;
}

/* Стили для логотипа в drawer */
.v-navigation-drawer .v-list-item {
  padding-top: env(safe-area-inset-top);
}

</style> -->